import React from 'react';
import { Shield } from 'lucide-react';

const Founder = () => {
  return (
    <section id="about" className="py-20 bg-gray-50 border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="grid lg:grid-cols-2 gap-12 items-start">
          <div className="relative flex justify-center lg:justify-start">
            <img 
              src="https://customer-assets.emergentagent.com/job_d9f78479-b1ec-4ee5-97ee-4214e41b9e45/artifacts/ytlepohp_IMG_2792.jpeg"
              alt="Professional Business Handshake"
              className="rounded-lg shadow-2xl w-full max-w-md aspect-[3/4] object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent rounded-lg max-w-md"></div>
          </div>

          <div>
            <div className="inline-flex items-center bg-[#FFD000]/10 px-4 py-2 rounded-full mb-6">
              <Shield className="h-6 w-6 text-[#FFD000] mr-2" />
              <span className="text-[#FFD000] font-semibold text-sm">Founder-Led Oversight</span>
            </div>

            <h2 className="text-3xl sm:text-4xl font-normal text-black mb-6" style={{ fontFamily: "'DM Serif Display', serif", textShadow: 'none', WebkitFontSmoothing: 'antialiased' }}>
              Direct Accountability on Every Placement
            </h2>
            
            <p className="text-xl text-gray-700 mb-4 leading-relaxed" style={{ fontFamily: "'DM Serif Display', serif" }}>
              YuZu operates under founder-level accountability. Every shortlist, every screening decision, every candidate evaluation carries direct oversight.
            </p>

            <p className="text-gray-700 text-sm mb-6 leading-relaxed">
              Every candidate goes through structured behavioural screening, informed by Marché's formal counselling and psychology qualification, with hospitality operational awareness built into every shortlist.
            </p>

            <div className="space-y-4 mb-6">
              <div className="flex items-start">
                <div className="w-12 h-12 bg-[#FFD000]/10 rounded-lg flex items-center justify-center flex-shrink-0 mr-4">
                  <div className="w-3 h-3 bg-[#FFD000] rounded-full"></div>
                </div>
                <div>
                  <p className="text-lg font-normal text-black">Directly involved in every shortlist</p>
                  <p className="text-gray-600 text-sm">No delegation. No shortcuts.</p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-12 h-12 bg-[#FFD000]/10 rounded-lg flex items-center justify-center flex-shrink-0 mr-4">
                  <div className="w-3 h-3 bg-[#FFD000] rounded-full"></div>
                </div>
                <div>
                  <p className="text-lg font-normal text-black">Operationally aware</p>
                  <p className="text-gray-600 text-sm">Hospitality-specific pressure points and risk factors.</p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-12 h-12 bg-[#FFD000]/10 rounded-lg flex items-center justify-center flex-shrink-0 mr-4">
                  <div className="w-3 h-3 bg-[#FFD000] rounded-full"></div>
                </div>
                <div>
                  <p className="text-lg font-normal text-black">Detail-oriented</p>
                  <p className="text-gray-600 text-sm">Structured validation at every stage.</p>
                </div>
              </div>
            </div>

            <div className="bg-gray-50 border-l-4 border-[#FFD000] p-6 rounded-lg">
              <p className="text-base font-semibold text-black">
                Every shortlist carries founder-level accountability.
              </p>
              <p className="text-gray-600 mt-2 text-sm">No exaggeration. No ego positioning.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Founder;
